export class InvalidMimeTypeError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'InvalidMimeTypeError';
  }
}
